

import React, { memo } from 'react';
import { BaseModal, Link, Text, Button, Icon } from '../../../ui-kit';
import { TUTORIAL_LINK, CAST_LITE_EXTENSION_LINK } from '../constants/links';

import '../styles/_download-app-modal.scss';











const openLink = (path) => {
  window.open(path, '_blank');
};

function downloadApp(props) {
  const { downloadMacIntel, downloadWindows64 } = props;

  let path;
  if (navigator.platform.includes('Mac')) {
    path = downloadMacIntel;
  }
  if (navigator.platform.includes('Win')) {
    path = downloadWindows64;
  }
  openLink(path);
}

function openTutorialPage() {
  window.open(TUTORIAL_LINK, '_blank');
}

function openCastLiteExtension() {
  window.open(CAST_LITE_EXTENSION_LINK, '_blank');
}

const DownloadCastAppModal = (props) => {
  const { downloadMacIntel, downloadWindows64, isVisible, onClose } = props;

  return (
    <BaseModal
      visible={isVisible}
      onClose={onClose}
      className="download-app-modal"
      size="XS">

      <div className="download-app-modal__inner">
        <Icon name="castoriginal" size={140} className="download-app-modal__inner-title" />
        <Text heading3 className="download-app-modal__inner-subtitle">
          Download Shootsta Cast to start recording!
        </Text>
        <div className="download-app-modal__inner-options-container">
          <Button
            className="download-app-modal__inner-options-container__action"
            onClick={() => downloadApp(props)}>

            <Text>Download Desktop App</Text>
          </Button>
        </div>
        <Text span>Or use a direct link for</Text>
        <Text span className="download-app-modal__inner-direct-links">
          {downloadMacIntel && (
            <a className="download-app-modal__inner-direct-link" href={downloadMacIntel}>
              <Icon name="apple" size={22} /> macOS
            </a>
          )}
          <span>|</span>
          {downloadWindows64 && (
            <a className="download-app-modal__inner-direct-link" href={downloadWindows64}>
              <Icon name="microsoftcolor" size={22} /> Windows x64
            </a>
          )}
        </Text>

        <div className="download-app-modal__inner-divider">
          <Text>or</Text>
        </div>

        <div className="download-app-modal__inner-lite">
          <Text heading5 className="download-app-modal__inner-lite-title">
            Prefer to record in your browser?
          </Text>
          <Button
            type="SECONDARY"
            className="download-app-modal__inner-lite__action"
            onClick={openCastLiteExtension}>

            <Text>Add Cast Lite to Chrome</Text>
          </Button>
        </div>

        <div className="download-app-modal__inner-footer">
          <Text>
            Trouble installing? Check our guide on
            <Link onClick={openTutorialPage}>How to Install Shootsta Cast</Link>
          </Text>
        </div>
      </div>
    </BaseModal>);

};

export default memo(DownloadCastAppModal);